// TES-1110 — the Support inbox's "Eskalera till vårdteamet", the pure parts.
//
// Pure on purpose (only type imports) so `node --test` can run it.
import type {
  ChatMessage,
  HandoffToRole,
  SupportEscalationResponse,
} from "@care-by-ella/contracts";

/** What staff read after pressing "Eskalera". */
export function supportEscalationOutcome(
  toRole: HandoffToRole,
  r: Pick<SupportEscalationResponse, "alreadyEscalated" | "redirectReply">,
): string {
  const who = toRole === "doctor" ? "läkaren" : "coachen";
  if (r.alreadyEscalated) {
    return `Redan eskalerat till ${who}, och ärendet är fortfarande öppet. Inget nytt skickades.`;
  }
  return `Eskalerat till ${who}.${
    r.redirectReply ? " Standardsvaret skickades till patienten." : ""
  }`;
}

/**
 * TES-1119 — whether the escalate form offers the Ö-333 standard reply. It
 * promises "Du får en notifiering när ett medicinskt besked finns under Din
 * vård", which only an escalation to the doctor can keep, so it is offered
 * for the doctor only, and only when the server has the text.
 */
export function standardReplyOffered(
  toRole: HandoffToRole,
  replyText: string | null,
): boolean {
  return toRole === "doctor" && !!replyText;
}

/**
 * A message staff can escalate on its own: one the patient wrote and has not
 * deleted. Ella Support's own messages are escalated as part of the thread.
 */
export function isEscalatableMessage(
  m: Pick<ChatMessage, "senderType" | "deletedAt">,
): boolean {
  return m.senderType === "patient" && !m.deletedAt;
}
